import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { getClientDetails, addLicense, removeLicense, extendLicense, renewLicense, deactivateAccount, activateAccount } from "../utils/Api";
import { handleLoaderEvent } from "../utils/LoaderEmitter";

import PlatformNavigation from "./PlatfromNavigation";
import DatePicker from "react-datepicker";
import moment from "moment";

import { Modal } from "react-bootstrap";
import { Image } from "@fluentui/react-northstar";
import { iconAssets } from "../assets/theme/theme";

import "react-datepicker/dist/react-datepicker.css";
import "../styles/ViewClient.css";

const ViewClient = () => {
  const [clientDetails, setClientDetails] = useState({});
  const [licenseDetails, setLicenseDetails] = useState({});
  const [clientAdmin, setClientAdmin] = useState({});
  const [addLicenseShow, setAddLicenseShow] = useState(false);
  const [removeLicenseShow, setRemoveLicenseShow] = useState(false);
  const [extendLicenseShow, setExtendLicenseShow] = useState(false);
  const [renewLicenseShow, setRenewLicenseShow] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [deactivateActionShow, setDeactivateActionShow] = useState(false);
  const [activateActionShow, setActivateActionShow] = useState(false);
  const [addLicenseValue, setAddLicenseValue] = useState(1);
  const [removeLicenseValue, setRemoveLicenseValue] = useState(1);
  const [extendLicenseValue, setExtendLicenseValue] = useState(1);
  const [renewLicenseValue, setRenewLicenseValue] = useState(1);
  const [renewMonthValue, setRenewMonthValue] = useState(1);

  const addLicenseHandleClose = () => setAddLicenseShow(false);
  const addLicenseHandleShow = () => setAddLicenseShow(true);
  const removeLicenseHandleClose = () => setRemoveLicenseShow(false);
  const removeLicenseHandleShow = () => setRemoveLicenseShow(true);
  const extendLicenseHandleClose = () => setExtendLicenseShow(false);
  const extendLicenseHandleShow = () => setExtendLicenseShow(true);
  const renewLicenseHandleClose = () => setRenewLicenseShow(false);
  const renewLicenseHandleShow = () => setRenewLicenseShow(true);
  const deactivateHandleClose = () => setDeactivateActionShow(false);
  const deactivateHandleShow = () => setDeactivateActionShow(true);
  const activateHandleClose = () => setActivateActionShow(false);
  const activateHandleShow = () => setActivateActionShow(true);

  let { id } = useParams();

  const saveAddedLicense = async (setAddLicenseShow, addLicenseValue, id) => {
    if (addLicenseValue < 1) {
      return toast.error("Value not less than 1");
    }
    let params = { numberOfLicense: addLicenseValue };
    let addedLicense = await addLicense(params, id);
    if (!addedLicense) {
      return;
    }
    setAddLicenseShow(false);
    refreshClientDetails();
    toast.info("License added successfully");
  };

  const saveRemovedLicense = async (setRemoveLicenseShow, removeLicenseValue, id) => {
    if (removeLicenseValue < 1) {
      return toast.error("Value not less than 1");
    }
    let params = { numberOfLicense: removeLicenseValue };
    let removedLicense = await removeLicense(params, id);
    if (!removedLicense) {
      return;
    }
    setRemoveLicenseShow(false);
    refreshClientDetails();
    toast.info("License removed successfully");
  };

  const saveExtendedLicense = async (setExtendLicenseShow, duration, extendLicenseValue, id) => {
    if (extendLicenseValue < 1) {
      return toast.error("Value not less than 1");
    }
    let params = { currentDuration: duration, numberOfMonths: extendLicenseValue };
    let extendedLicense = await extendLicense(params, id);
    if (!extendedLicense) {
      return;
    }
    setExtendLicenseShow(false);
    refreshClientDetails();
    toast.info("License extended successfully");
  };

  const saveRenewLicense = async (setRenewLicenseShow, startDate, renewLicenseValue, renewMonthValue, id) => {
    try {
      if (renewLicenseValue < 1 || renewMonthValue < 1) {
        return toast.error("Value not less than 1");
      }
      let params = { customerId: id, duration: renewMonthValue, numberOfLicenses: renewLicenseValue, startDate: startDate };
      let renewedLicense = await renewLicense(params, id);
      if (!renewedLicense) {
        return;
      }
      setRenewLicenseShow(false);
      refreshClientDetails();
      toast.info("License renewed successfully");
    } catch (exception) {
      toast.error(exception?.response?.data?.message);
    }
  };

  const deactiveAccountProcess = async (id, setDeactivateActionShow) => {
    let accountDeactivated = await deactivateAccount(id);

    if (!accountDeactivated) {
      return;
    }
    setDeactivateActionShow(false);
    refreshClientDetails();
    toast.info("License deactivated successfully");
  };

  const activeAccountProcess = async (id, setActivateActionShow) => {
    let accountActivated = await activateAccount(id);

    if (!accountActivated) {
      return;
    }
    setActivateActionShow(false);
    refreshClientDetails();
    toast.info("License activated successfully");
  };

  const refreshClientDetails = async () => {
    handleLoaderEvent.emit("loader", true);
    setLicenseDetails({});
    setClientAdmin({});
    setClientDetails({});
    let clientInfo = await getClientDetails(id);
    if (!clientInfo) {
      return;
    }
    setLicenseDetails(clientInfo["licenseDetails"]);
    setRenewLicenseValue(clientInfo["licenseDetails"]["numberOfLicenseUsed"]);
    setClientAdmin(clientInfo["customerAdmin"]);
    setClientDetails(clientInfo["customer"]);

    handleLoaderEvent.emit("loader", false);
  };

  useEffect(() => {
    refreshClientDetails();
  }, []);

  const handleAddLicenseChange = (e) => {
    setAddLicenseValue((v) => (e.target.validity.valid ? e.target.value : v));
  };

  const increaseAddLicense = () => {
    setAddLicenseValue(Number(addLicenseValue) + 1);
  };

  const decreaseAddLicense = () => {
    setAddLicenseValue((v) => (Number(addLicenseValue) > 0 ? Number(addLicenseValue) - 1 : v));
  };

  const handleRemoveLicenseChange = (e) => {
    setRemoveLicenseValue((v) => (e.target.validity.valid ? e.target.value : v));
  };

  const increaseRemoveLicense = () => {
    setRemoveLicenseValue(Number(removeLicenseValue) + 1);
  };

  const decreaseRemoveLicense = () => {
    setRemoveLicenseValue((v) => (Number(removeLicenseValue) > 0 ? Number(removeLicenseValue) - 1 : v));
  };

  const handleExtendLicenseChange = (e) => {
    setExtendLicenseValue((v) => (e.target.validity.valid ? e.target.value : v));
  };

  const increaseExtendLicense = () => {
    setExtendLicenseValue(Number(extendLicenseValue) + 1);
  };

  const decreaseExtendLicense = () => {
    setExtendLicenseValue((v) => (Number(extendLicenseValue) > 0 ? Number(extendLicenseValue) - 1 : v));
  };

  const handleRenewLicenseChange = (e) => {
    setRenewLicenseValue((v) => (e.target.validity.valid ? e.target.value : v));
  };

  const increaseRenewLicense = () => {
    setRenewLicenseValue(Number(renewLicenseValue) + 1);
  };

  const decreaseRenewLicense = () => {
    setRenewLicenseValue((v) => (Number(renewLicenseValue) > 0 ? Number(renewLicenseValue) - 1 : v));
  };

  const handleRenewMonthChange = (e) => {
    setRenewMonthValue((v) => (e.target.validity.valid ? e.target.value : v));
  };

  const increaseRenewMonth = () => {
    setRenewMonthValue(Number(renewMonthValue) + 1);
  };

  const decreaseRenewMonth = () => {
    setRenewMonthValue((v) => (Number(renewMonthValue) > 0 ? Number(renewMonthValue) - 1 : v));
  };

  return (
    <div>
      <PlatformNavigation id={id} selectedTab={"Client Dashboard"} clientName={clientDetails["name"]} />
      <div className="row p-0 m-0 w-100 mt-5">
        <div className="col-auto px-2 d-flex align-items-center">
          <div className="row p-0 m-0">
            <div className="col-auto pe-1">
              <Image src={iconAssets.phone} alt="" className="phone-icon" />
            </div>
            <div className="col-auto ps-1 d-flex align-items-center">{clientDetails["phone"]}</div>
          </div>
        </div>
        <div className="col-auto px-2 d-flex align-items-center">
          <div className="row p-0 m-0">
            <div className="col-auto pe-1">
              <Image src={iconAssets.email} alt="" className="email-icon" />
            </div>
            <div className="col-auto ps-1 d-flex align-items-center">{clientDetails["email"]}</div>
          </div>
        </div>
        <div className="col-auto px-2 d-flex align-items-center">
          <div className="row p-0 m-0">
            <div className="col-auto pe-1">
              <Image src={iconAssets.web} alt="" className="web-icon" />
            </div>
            <div className="col-auto ps-1 d-flex align-items-center">{clientDetails["domain_name"]}</div>
          </div>
        </div>
        <div className="col px-2 ps-4 d-flex justify-content-end">
          {clientDetails["status"] == true ? (
            <button className="view-deactivate-button p-2 px-4" onClick={deactivateHandleShow}>
              Deactivate
            </button>
          ) : (
            <button className="view-activate-button p-2 px-4" onClick={activateHandleShow}>
              Activate
            </button>
          )}
        </div>
      </div>
      <div className="content-title mt-5 p-2 px-4">Admin</div>
      <div className="row p-2 px-4 m-0 w-100 mt-2 content-description">
        <div className="col-3 p-0">
          {clientAdmin["first_name"]} {clientAdmin["last_name"]}
        </div>
        <div className="col p-0">
          <div className="row p-0 m-0">
            <div className="col-auto p-0">
              <Image src={iconAssets.email} alt="" className="email-icon" />
            </div>
            <div className="col-auto ps-2">{clientAdmin["email"]}</div>
          </div>
        </div>
      </div>
      <div className="content-title row p-0 m-0 mt-5 p-2 px-4">
        <div className="col-auto p-0 content-title-text">License</div>
        <div className="col"></div>
        {clientDetails["status"] == true && (
          <>
            <div className="col-auto">
              <div className="row p-0 m-0 cursor-pointer" onClick={addLicenseHandleShow}>
                <div className="col-auto pe-1 d-flex align-items-center">
                  <Image src={iconAssets.add} alt="" className="add-icon" />
                </div>
                <div className="col-auto ps-0 content-title-sub-text d-flex align-items-center">Add</div>
              </div>
            </div>
            <div className="col-auto">
              <div className="row p-0 m-0 cursor-pointer" onClick={removeLicenseHandleShow}>
                <div className="col-auto pe-1 d-flex align-items-center">
                  <Image src={iconAssets.delete} alt="" className="delete-icon" />
                </div>
                <div className="col-auto ps-0 content-title-sub-text d-flex align-items-center">Remove</div>
              </div>
            </div>
            <div className="col-auto">
              <div className="row p-0 m-0 cursor-pointer" onClick={extendLicenseHandleShow}>
                <div className="col-auto pe-1 d-flex align-items-center">
                  <Image src={iconAssets.extend} alt="" className="extend-icon" />
                </div>
                <div className="col-auto ps-0 content-title-sub-text d-flex align-items-center">Extend</div>
              </div>
            </div>
            <div className="col-auto">
              <div className="row p-0 m-0 cursor-pointer" onClick={renewLicenseHandleShow}>
                <div className="col-auto pe-1 d-flex align-items-center">
                  <Image src={iconAssets.refresh} alt="" className="refresh-icon" />
                </div>
                <div className="col-auto ps-0 content-title-sub-text d-flex align-items-center">Renew</div>
              </div>
            </div>
          </>
        )}
      </div>
      <div className="row p-0 m-0 w-100 mt-2">
        <div className="col">
          <div className="license-title">Total number of license</div>
          <hr className="mt-0 mb-1"></hr>
          <div className="license-description">{licenseDetails["totalNumberOfLicenses"]}</div>
        </div>
        <div className="col">
          <div className="license-title">Number of used License</div>
          <hr className="mt-0 mb-1"></hr>
          <div className="license-description">{licenseDetails["numberOfLicenseUsed"]}</div>
        </div>
        <div className="col">
          <div className="license-title">License start date</div>
          <hr className="mt-0 mb-1"></hr>
          <div className="license-description">{moment(licenseDetails["startDate"]).format("DD MMM, YYYY")}</div>
        </div>
        <div className="col">
          <div className="license-title">Expiry date</div>
          <hr className="mt-0 mb-1"></hr>
          <div className="license-description">{moment(licenseDetails["expiryDate"]).format("DD MMM, YYYY")}</div>
        </div>
        <div className="col">
          <div className="license-title">Duration(Months)</div>
          <hr className="mt-0 mb-1"></hr>
          <div className="license-description">{licenseDetails["duration"]}</div>
        </div>
      </div>

      <Modal className="activation-modal" show={deactivateActionShow} onHide={deactivateHandleClose}>
        <Modal.Body>
          <Modal.Title className="status-modal-title text-center">Confirm Action</Modal.Title>
          <div className="status-modal-sub-title mt-4 text-center">Are you sure you want to deactivate the client, {clientDetails["name"]}?</div>

          <div className="d-flex justify-content-end mt-5">
            <button className="cancel-button p-2 px-4 me-3" onClick={deactivateHandleClose}>
              Cancel
            </button>
            <button className="save-button p-2 px-4" onClick={() => deactiveAccountProcess(clientDetails["id"], setDeactivateActionShow)}>
              Deactivate
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="activation-modal" show={activateActionShow} onHide={activateHandleClose}>
        <Modal.Body>
          <Modal.Title className="status-modal-title text-center">Confirm Action</Modal.Title>
          <div className="status-modal-sub-title mt-4 text-center">Are you sure you want to activate the client, {clientDetails["name"]}?</div>

          <div className="d-flex justify-content-end mt-5">
            <button className="cancel-button p-2 px-4 me-3" onClick={activateHandleClose}>
              Cancel
            </button>
            <button className="save-button p-2 px-4" onClick={() => activeAccountProcess(clientDetails["id"], setActivateActionShow)}>
              Activate
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="add-license-modal" show={addLicenseShow} onHide={addLicenseHandleClose}>
        <Modal.Body>
          <Modal.Title>Add License</Modal.Title>
          <div className="add-sub-title mt-4">Number of Licenses</div>
          <div className="row p-0 m-0 mt-2 w-75 content-border">
            <div className="col-auto p-2 px-4 cursor-pointer" onClick={decreaseAddLicense}>
              -
            </div>
            <div className="col p-2 px-4 content-border-left license-textbox input-align">
              <input type="text" value={addLicenseValue} pattern="[0-9]*" onChange={handleAddLicenseChange}></input>
            </div>
            <div className="col-auto p-2 px-4 content-border-left cursor-pointer" onClick={increaseAddLicense}>
              +
            </div>
          </div>
          <div className="d-flex justify-content-end mt-3">
            <button className="cancel-button p-2 px-4 me-3" onClick={addLicenseHandleClose}>
              Cancel
            </button>
            <button className="save-button p-2 px-4" onClick={() => saveAddedLicense(setAddLicenseShow, addLicenseValue, id)}>
              Save
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="add-license-modal" show={removeLicenseShow} onHide={removeLicenseHandleClose}>
        <Modal.Body>
          <Modal.Title>Remove License</Modal.Title>
          <div className="add-sub-title mt-4">Number of Licenses</div>
          <div className="row p-0 m-0 mt-2 w-75 content-border">
            <div className="col-auto p-2 px-4 cursor-pointer" onClick={decreaseRemoveLicense}>
              -
            </div>
            <div className="col p-2 px-4 content-border-left license-textbox">
              <input type="text" value={removeLicenseValue} pattern="[0-9]*" onChange={handleRemoveLicenseChange}></input>
            </div>
            <div className="col-auto p-2 px-4 content-border-left cursor-pointer" onClick={increaseRemoveLicense}>
              +
            </div>
          </div>
          <div className="d-flex justify-content-end mt-3">
            <button className="cancel-button p-2 px-4 me-3" onClick={removeLicenseHandleClose}>
              Cancel
            </button>
            <button className="save-button p-2 px-4" onClick={() => saveRemovedLicense(setRemoveLicenseShow, removeLicenseValue, id)}>
              Save
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="add-license-modal" show={extendLicenseShow} onHide={extendLicenseHandleClose}>
        <Modal.Body>
          <Modal.Title>Extend License</Modal.Title>
          <div className="row p-0 m-0 w-100 mt-4">
            <div className="col-6 p-0">
              <div className="title-light">Start date</div>
              <div>{moment(licenseDetails["startDate"]).format("DD MMM, YYYY")}</div>
            </div>
            <div className="col-6 p-0">
              <div>Duration (Months)</div>
              <div>{licenseDetails["duration"]}</div>
            </div>
          </div>
          <div className="add-sub-title mt-3">Extend (Months)</div>
          <div className="row p-0 m-0 mt-2 w-75 content-border">
            <div className="col-auto p-2 px-4 cursor-pointer" onClick={decreaseExtendLicense}>
              -
            </div>
            <div className="col p-0 p-2 px-4 content-border-left license-textbox input-align">
              <input type="text" value={extendLicenseValue} pattern="[0-9]*" onChange={handleExtendLicenseChange}></input>
            </div>
            <div className="col-auto p-2 px-4 content-border-left cursor-pointer" onClick={increaseExtendLicense}>
              +
            </div>
          </div>
          <div className="d-flex justify-content-end mt-3">
            <button className="cancel-button p-2 px-4 me-3" onClick={extendLicenseHandleClose}>
              Cancel
            </button>
            <button className="save-button p-2 px-4" onClick={() => saveExtendedLicense(setExtendLicenseShow, licenseDetails["duration"], extendLicenseValue, id)}>
              Save
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="renew-license-modal" show={renewLicenseShow} onHide={renewLicenseHandleClose}>
        <Modal.Body>
          <Modal.Title>Renew License</Modal.Title>
          <div className="row p-0 m-0 w-100">
            <div className="col-4">
              <div className="add-sub-title mt-3">No of licenses*</div>
              <div className="row p-0 m-0 mt-2 content-border">
                <div className="col-auto p-2 px-4 cursor-pointer" onClick={decreaseRenewLicense}>
                  -
                </div>
                <div className="col p-0 p-2 content-border-left license-textbox input-align">
                  <input type="text" value={renewLicenseValue} pattern="[0-9]*" onChange={handleRenewLicenseChange}></input>
                </div>
                <div className="col-auto p-2 px-4 content-border-left cursor-pointer" onClick={increaseRenewLicense}>
                  +
                </div>
              </div>
            </div>
            <div className="col-4 date-selector">
              <div className="add-sub-title mt-3">Start Date</div>
              <DatePicker className="mt-2" selected={startDate} onChange={(date) => setStartDate(date)} />
            </div>
            <div className="col-4">
              <div className="add-sub-title mt-3">Duration(Months)*</div>
              <div className="row p-0 m-0 mt-2 content-border">
                <div className="col-auto p-2 px-4 cursor-pointer" onClick={decreaseRenewMonth}>
                  -
                </div>
                <div className="col p-0 p-2 content-border-left license-textbox input-align">
                  <input type="text" value={renewMonthValue} pattern="[0-9]*" onChange={handleRenewMonthChange}></input>
                </div>
                <div className="col-auto p-2 px-4 content-border-left cursor-pointer" onClick={increaseRenewMonth}>
                  +
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end mt-3">
            <button className="cancel-button p-2 px-4 me-3" onClick={renewLicenseHandleClose}>
              Cancel
            </button>
            <button className="save-button p-2 px-4" onClick={() => saveRenewLicense(setRenewLicenseShow, startDate, renewLicenseValue, renewMonthValue, id)}>
              Save
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ViewClient;
